<template>
  <div
    id="pageCasino"
    class="d-flex flex-column main-casino"
    :class="{ 'h-100': !isHauteurPageAutomatique }"
  >
    <div :class="[content.theme, getStatusMenuGauche ? 'menu-ouvert' : 'menu-ferme']">
      <vue-headful
        :title="metaData.title"
        :description="metaData.description"
        :keywords="metaData.keywords"
        :image="metaData.metaOGImage"
        :url="metaUrl"
        :head="{
          'meta[name=robots]': { content: metaData.metaNoIndex },
          'link[hreflang=en-ca]': { href: pathAnglais },
          'link[hreflang=fr-ca]': { href: pathFrancais },
          'link[rel=apple-touch-icon]': { type: 'image/png' },
          'link[rel=icon]': { type: 'image/png' },
        }"
      />

      <!-- Ces 2 spans évitent erreur dans barreconnect-app.js -->
      <!-- TODO: À corriger dans lq-entete-connexion -->
      <!-- TODO: 2021-11-10 à détruire? Conserver cette ligne cause un doublon au niveau des id de la page. -->
      <!-- <span id="mel-topNotif"></span><span id="mel-notif"></span> -->

      <div
        class="w-100 h-100 d-flex align-items-start"
        :class="
          content.theme == 'casinoClair'
            ? 'themeClair'
            : { themeFonce: content.theme == 'casinoFonce' }
        "
      >
        <Heritage
          v-if="content.themeMenu !== 'invisible'"
          :key="componentKey"
          class="d-none d-lg-flex px-0 navbar-gauche position-sticky vh-100"
          :content="contentHeritageMenuGauche"
        />
        <main class="d-flex align-items-center h-100 px-0 overflow-hidden">
          <EditableArea
            v-if="content.main"
            :key="componentKey"
            class="w-100 h-100"
            :content="content.main"
          />
          <IframeHtmlSalesforce
            v-if="isAfficherClavardage"
            :positionBulle="content.positionBulle"
          />
        </main>
        <Heritage :content="contentHeritageModalNewsletter" />
      </div>

      <Heritage
        v-if="content.themeMenu !== 'invisible' && isMenuBasVisible"
        :key="componentKey"
        class="navbar-bas d-lg-none"
        :content="contentHeritageMenuBas"
      />
      <footer
        v-if="isPiedDePageVisible"
        id="footer"
        class="p-0"
        :class="$isMobile ? 'compteFonce' : content.themePiedDePage"
      >
        <Heritage :key="componentKey" class="piedDePage" :content="contentHeritage" />
      </footer>
    </div>
  </div>
</template>

<script>
import vueHeadful from 'vue-headful';
import { mapGetters } from 'vuex';
import { EditableArea } from '@/vue-editor';
import { bus } from '@/main';

import Heritage from '@/components/base/Heritage';
import IframeHtmlSalesforce from '@/components/base/IframeHtmlSalesforce';

import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

import { inMgnl } from '@/helpers/AppHelpers';
import { stripAllHtmlTag } from '@/helpers/StringHelpers';

import session from '@/services/api/compte/session';

export default {
  name: 'Casino',
  components: {
    EditableArea,
    Heritage,
    vueHeadful,
    IframeHtmlSalesforce,
  },
  mixins: [mixinEnvironnement],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      contentHeritage: { lienInterne: process.env.VUE_APP_JEL_NOEUD_CASINO_PIEDDEPAGE },
      contentHeritageMenuGauche: {
        lienInterne: process.env.VUE_APP_JEL_NOEUD_CASINO_MENUGAUCHE,
      },
      contentHeritageMenuBas: { lienInterne: process.env.VUE_APP_JEL_NOEUD_CASINO_MENUBAS },
      contentHeritageModalNewsletter: {
        lienInterne: process.env.VUE_APP_JEL_NOEUD_MODALNEWSLETTER,
      },
      metaUrl: document.URL,
      isMenuBasVisible: true,
      // componentKey est utilisé pour raffraîchir les composants lors d'une ouverture de session
      componentKey: 0,
      metaData: {
        title: '',
        description: '',
        keywords: '',
        metaNoIndex: '',
        metaOGImage: '',
      },
      modaleNewsletter: {
        titre: null,
        message: null,
        moreInfo: null,
        accepterRecevoirMessage: null,
        optIn: null,
      },
      modaleNewsletterConfirmation: {
        titre: null,
        message: null,
      },
      modaleNewsletterErreur: {
        titre: null,
        message: null,
      },
      message: null,
      messageErreur: {
        idHTML: 'erreurNewsletter',
        idHTMLContenu: 'contenuErreur',
      },
      pathFrancais: '',
      pathAnglais: '',
    };
  },
  computed: {
    ...mapGetters({
      getIsMenuGaucheOuvert: 'menu/getIsMenuGaucheOuvert',
    }),
    getStatusMenuGauche() {
      if (this.getIsMenuGaucheOuvert != null) return this.getIsMenuGaucheOuvert;
      return this.$mq == 'xl' || this.$mq == 'xxl';
    },
    isPiedDePageVisible() {
      return (
        (!this.content.themePiedDePage || this.content.themePiedDePage != 'invisible') &&
        !this.mixinEnvironnement_inAppMobile
      );
    },
    isHauteurPageAutomatique() {
      return this.content.hauteurPageAutomatique || this.jel_isIPhoneOrIPod();
    },
    isAfficherClavardage() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('clavardage_ouvert') === 'true';
    },
    state() {
      return this.subscribeNewsletter != false;
    },
    // State du checkbox de la modale MAS en direct
    subscribeNewsletter: {
      get() {
        return this.modaleNewsletter.optIn;
      },
      set(value) {
        this.modaleNewsletter.optIn = value;
        this.message = null;
      },
    },
    enSavoirPlus() {
      return {
        texte: this.$i18n.t('casino.newsletter.modale.moreInfo'),
        type: 'lienSecondaire',
        lien: {
          field: 'lienExterne',
          lienExterne: this.$i18n.t('casino.newsletter.modale.urlEnSavoirPlus'),
        },
        classeCSS: 'd-flex d-inline-flex',
      };
    },
  },
  activated() {
    document.body.scrollTop = 0;
  },
  mounted() {
    document.addEventListener('ejEventLogin', this.ejLoginEventListener);

    // TODO: Revoir le chargement du css pour ne pas qu'il soit constamment ré-exécuté (à essayer dans le created mais idéalement revoir le chargement à la source)
    // Empêcher le logo Loto-Québec de la barre portail de s'afficher momentanément pleine grandeur
    if (!inMgnl) {
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.type = 'text/css';
      style.href = '/mel/.resources/lq-entete-commun/webresources/css/barreportail-app.css?v=210';
      document.head.append(style);
    }

    this.$store.commit('produitCollection/INIT');
    this.$store.commit('produitCasino/INIT');
    // this.$store.commit('cedTable/INIT');
    this.$store.commit('progressif/INIT');
    this.$store.commit('integrateur/INIT');
    this.$store.commit('fournisseur/INIT');
    this.$store.commit('etiquette/INIT');

    document.body.scrollTop = 0; // forcer la page à charger en haut de page pour régler un problème sur mobile

    this.busEmitNouvellePage();

    bus.$on('afficherMenuBas', (affichage) => {
      this.isMenuBasVisible = affichage;
    });

    bus.$on('urlAutreLangue', (url) => {
      this.miseAJourMetaLien(url);
    });

    bus.$on('headerProduitInfo', (info) => {
      this.miseAjourMetaInfo(info);
    });

    const uri = this.$store.getters['routes/getPathAutreLangue'](window.location.pathname.slice(3));
    this.miseAJourMetaLien(uri);
    this.miseAjourMetaInfo(this.content);

    // Lors du premier click dans le vide (body) la page remonte automatiquement au top, ceci est une patch pour conserver le scroll au bon endroit
    document.body.addEventListener('click', this.fixFirstClickScrollTop);
  },
  beforeDestroy() {
    document.removeEventListener('ejEventLogin', this.ejLoginEventListener);
    this.removeInitialClickListener();
  },
  methods: {
    afficherMessageErreur(msg) {
      const span = document.getElementById('contenuErreur');
      span.textContent = msg;
    },
    ejLoginEventListener() {
      // componentKey est utilisé pour raffraîchir les composants lors d'une ouverture de session
      // Réf: https://michaelnthiessen.com/force-re-render/
      this.componentKey++;
      if (session.sessionEstOuverte()) {
        this.$store.dispatch('preferences/getPreferences');
      }
    },
    busEmitNouvellePage() {
      const self = this;
      bus.$emit('NouvellePageMounted', {
        afficherNavigation: self.content.afficherNavigation == 'true',
        theme: self.content.theme,
        themeLogoNav: self.content.themeLogoNav,
      });
    },
    miseAJourMetaLien(url) {
      this.pathFrancais = this.metaUrl.includes('/fr/')
        ? this.metaUrl
        : window.location.origin + url;
      this.pathAnglais = this.metaUrl.includes('/en/')
        ? this.metaUrl
        : window.location.origin + url;
    },
    miseAjourMetaInfo(info) {
      this.metaData.title = `${info.title ? info.title : ''} | Loto-Québec`;
      this.metaData.description = info.description ? stripAllHtmlTag(info.description) : '';
      this.metaData.keywords = info.keywords ? info.keywords : '';
      this.metaData.metaNoIndex = info.noindex == 'true' ? 'noindex' : 'index, follow';
      this.metaData.metaOGImage = info.metaOGImage ? this.jel_getFichierSrc(info.metaOGImage) : '';
    },
    fixFirstClickScrollTop() {
      const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

      if (isChrome) {
        const scrolled = document.body.scrollTop;

        document.body.scroll({
          top: scrolled,
          behavior: 'smooth',
        });
      }
      this.removeInitialClickListener();
    },
    removeInitialClickListener() {
      document.body.removeEventListener('click', this.fixFirstClickScrollTop);
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

.navbar-bas {
  overflow: hidden;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
}

.navbar-gauche {
  height: auto;
  align-self: flex-start;
  background-color: white;
  z-index: 1;
  top: 0;
  left: 0;
  ::v-deep .overflow-auto {
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
@media screen and (max-height: 450px) {
  .navbar-gauche {
    padding-top: 15px;
    a {
      font-size: 18px;
    }
  }
}

.main-casino {
  @include media-breakpoint-down(md) {
    margin-bottom: 32px;
  }
}

main {
  width: inherit;
}
</style>
